module.exports = __webpack_public_path__ + "static/img/SingaporeYuSiangChieng.17265b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/SingaporeYuSiangChieng.jpg
// module id = ZFzw
// module chunks = 0